import { useState } from 'react';
import { ChevronRight, Check, Star, Award, Settings, ShoppingCart, Clock, Shield } from 'lucide-react';
import img1 from '../Components/Images/Sunmi/sunmi_cover.png'
import img2 from '../Components/Images/Sunmi/sunmi-cover1.png'
import img3 from '../Components/Images/Sunmi/l2s.png'
import img4 from '../Components/Images/Sunmi/t3pro.png'
import img5 from '../Components/Images/Sunmi/v2s.png'
import img6 from '../Components/Images/Sunmi/v3mix.png'
import img7 from '../Components/Images/Sunmi/d2.png'
import img8 from '../Components/Images/Sunmi/t2.png'

const Sunmiclaude = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [hoveredProduct, setHoveredProduct] = useState(null);


  // Product data
  const sunmiproduct=[img3, img4, img5, img6, img7, img8];
  const products = [
    {
      id: 1,
      name: "Sunmi V3 Mix",
      category: "Mobile terminals",
      type: "Smart POS Terminal",
      price: "Contact for pricing",
      features: [
        "15.6\" Large Touch Display",
        "Android 9.0 OS",
        "Quad-core 2.0GHz Processor",
        "Built-in Printer",
        "Face Recognition"
      ],
      description: "The V3 Mix is an all-in-one smart POS terminal designed for retail and restaurant environments. With a large 15.6\" touch display and built-in printer, it combines powerful performance with elegant design.",
      isNew: true,
      isBestseller: true,
      image:img6
    },
    {
      id: 2,
      name: "Sunmi V2S",
      category: "Mobile terminals",
      type: "Mobile POS Terminal",
      price: "Contact for pricing",
      features: [
        "5.99\" HD Touch Display",
        "Android 7.1 OS",
        "Quad-core Processor",
        "Built-in Printer",
        "4G/WiFi Connectivity"
      ],
      description: "The V2S is a handheld POS terminal perfect for queue-busting and table service. Compact yet powerful with an integrated printer and barcode scanner.",
      isNew: false,
      isBestseller: true,
      image:img5
    },
    {
      id: 3,
      name: "Sunmi L2S",
      category: "Mobile terminals",
      type: "Desktop POS Terminal",
      price: "Contact for pricing",
      features: [
        "14\" Touch Display",
        "Android 7.1 OS",
        "High-speed Thermal Printer",
        "Dual Display Option",
        "Multiple Interface Ports"
      ],
      description: "The L2S is a sophisticated desktop POS solution with a sleek design. Features a high-speed printer and optional customer-facing display for enhanced service.",
      isNew: false,
      isBestseller: false,
      image:img3

    },
    {
      id: 4,
      name: "Sunmi T2 Desktop",
      category: "Desktop terminals",
      type: "Smart Desktop Terminal",
      price: "Contact for pricing",
      features: [
        "15.6\" Full HD Display",
        "Android 7.1 OS",
        "Powerful Quad-core CPU",
        "Multiple I/O Ports",
        "Elegant Design"
      ],
      description: "The T2 Desktop terminal combines powerful performance with beautiful design. Perfect for high-volume retail environments requiring sophisticated POS solutions.",
      isNew: false,
      isBestseller: false,
      image:img8
    },
    {
      id: 5,
      name: "Sunmi D2 Desktop",
      category: "Desktop terminals",
      type: "Mini Desktop POS",
      price: "Contact for pricing",
      features: [
        "HD touchscreen with anti-fingerprint coating",
        "Quad-core processor for efficient performance",
        "2GB/4GB RAM and 16GB/32GB ROM options",
        "Connectivity: Wi-Fi, Bluetooth, Ethernet",
        "Compact and modern design"
      ],
      description: "The SUNMI D2 is a compact and cost-effective desktop POS system designed for small to medium-sized businesses. It offers essential functionalities in a sleek form factor, making it ideal for retail and hospitality environments.",
      isNew: false,
      isBestseller: false,
      image:img7
    },
    {
      id: 6,
      name: "Sunmi T3 Pro",
      category: "Desktop terminals",
      type: "Performant desktop pos",
      price: "Contact for pricing",
      features: [
        "Adjustable Viewing Angle",
        "Customizable Configurations",
        "Powerful Processor",
        "Low Maintenance",
        "Fingerprint unlocking"
      ],
      description: "The SUNMI T3 Pro is a flagship desktop POS terminal engineered for high-traffic retail and hospitality sectors. It offers advanced processing power, a premium display, and extensive connectivity options to streamline operations.",
      isNew: true,
      isBestseller: false,
      image:img4
    }
  ];

  // Filter products based on active tab
  const filteredProducts = activeTab === 'all' 
    ? products 
    : products.filter(product => product.category === activeTab);

  return (
    <div className="sunmi-showcase">
        <section>
            <div>
                <img src={img2} alt="" style={{borderRadius:"0px"}}></img>
            </div>
        </section>
      {/* Hero Section */}
      {/* <section className="hero bg-gradient-to-r from-blue-900 to-cyan-800  py-16" style={{color:"#fd7e14"}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 pe-lg-5">
              <h1 className="display-6 fw-bold mb-4">Authorized Sunmi Dealer in Bahrain</h1>
              <p className="lead mb-5">Transform your business with cutting-edge POS solutions, printers, and weighing systems. Professional-grade hardware for modern retail and service businesses.</p>
              <div className="d-flex gap-3">
                <a href="#products" className="btn btn-light btn-lg px-4 fw-bold">
                  View Products
                </a>
                <a href="#contact" className="btn btn-outline-light btn-lg px-4">
                  Contact Us
                </a>
              </div>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="position-relative">
                <img 
                  src={img1}
                  alt="Sunmi POS Display" 
                  className="img-fluid rounded-3 shadow-lg"
                />
                <div className="position-absolute top-0 end-0 bg-gradient-to-bl from-warning to-danger text-white px-3 py-2 rounded-pill fw-bold" style={{ marginTop: '-15px', marginRight: '-15px' }}>
                  Official Dealer
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Brands & Trust Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-4">
            <p className="text-uppercase fw-bold text-secondary mb-0">Trusted by businesses across Bahrain</p>
          </div>
          <div className="row justify-content-center align-items-center g-4">
            {sunmiproduct.map((brand) => (
              <div key={brand} className="col-4 col-md-2">
                <div className="py-3 px-4 text-center  grayscale">
                  <img src={brand} alt={`Brand ${brand}`} className="img-fluid" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-12 bg-white">
        <div className="container">
          <div className="row mb-5 mt-5">
            <div className="col-lg-6">
              <h2 className="fw-bold position-relative mb-4 display-6">
                Our Sunmi Product Range
                <div className="position-absolute" style={{ height: '4px', width: '80px', background: '#0891b2', bottom: '-12px', borderRadius: '2px' }}></div>
              </h2>
              <p className="text-secondary lead">
                Discover our comprehensive range of Sunmi POS terminals and printing solutions designed for modern businesses.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="d-flex justify-content-lg-end mt-4 mt-lg-0">
                <ul className="nav nav-pills product-filter">
                  <li className="nav-item me-2">
                    <button 
                      className={`nav-link px-4 rounded-pill ${activeTab === 'all' ? 'active bg-cyan-600' : ''}`} 
                      onClick={() => setActiveTab('all')}
                    >
                      All Products
                    </button>
                  </li>
                  <li className="nav-item me-2">
                    <button 
                      className={`nav-link px-4 rounded-pill ${activeTab === 'Desktop terminals' ? 'active bg-cyan-600' : ''}`} 
                      onClick={() => setActiveTab('Desktop terminals')}
                    >
                      Desktop Terminals
                    </button>
                  </li>
                  <li className="nav-item">
                    <button 
                      className={`nav-link px-4 rounded-pill ${activeTab === 'Mobile terminals' ? 'active bg-cyan-600' : ''}`} 
                      onClick={() => setActiveTab('Mobile terminals')}
                    >
                      Mobile Terminals
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row g-4">
            {filteredProducts.map((product) => (
              <div key={product.id} className="col-md-6 col-lg-4">
                <div 
                  className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden product-card"
                  onMouseEnter={() => setHoveredProduct(product.id)}
                  onMouseLeave={() => setHoveredProduct(null)}
                  style={{ 
                    transform: hoveredProduct === product.id ? 'translateY(-10px)' : 'translateY(0)',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    boxShadow: hoveredProduct === product.id ? '0 15px 30px rgba(0,0,0,0.1)' : '0 5px 15px rgba(0,0,0,0.05)'
                  }}
                >
                  <div className="position-relative">
                    {product.isNew && (
                      <div className="badge bg-success position-absolute top-0 start-0 m-3 fw-normal px-3 py-2 rounded-pill">
                        NEW
                      </div>
                    )}
                    {product.isBestseller && (
                      <div className="badge bg-warning text-dark position-absolute top-0 end-0 m-3 fw-normal px-3 py-2 rounded-pill">
                        BESTSELLER
                      </div>
                    )}
                    <div className="p-4">
                      <img 
                        src={product.image} 
                        className="img-fluid" 
                        alt={product.name} 
                        style={{
                          height: '220px',
                          objectFit: 'contain',
                          transition: 'transform 0.5s ease',
                          transform: hoveredProduct === product.id ? 'scale(1.05)' : 'scale(1)'
                        }}
                      />
                    </div>
                  </div>
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="badge bg-light text-secondary fw-normal">{product.type}</span>
                      <span className="fs-6 fw-bold text-primary">{product.price}</span>
                    </div>
                    <h3 className="h5 fw-bold mb-3">{product.name}</h3>
                    <p className="text-secondary mb-4 small">{product.description}</p>
                    
                    <div className="mb-4">
                      <h6 className="fw-bold mb-2 small text-uppercase text-secondary">Key Features</h6>
                      <ul className="list-unstyled">
                        {product.features.slice(0, 3).map((feature, i) => (
                          <li key={i} className="d-flex align-items-center mb-2 small">
                            <Check size={14} className="text-success me-2 flex-shrink-0" />
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <a 
                      href={`/products/${product.id}`}
                      className="btn btn-outline-primary w-100 d-flex justify-content-between align-items-center"
                      style={{
                        borderColor: '#0891b2',
                        color: '#0891b2',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#0891b2';
                        e.currentTarget.style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = '#0891b2';
                      }}
                    >
                      View Details
                      <ChevronRight size={18} className="ms-1" style={{
                        transition: 'transform 0.3s ease',
                        transform: hoveredProduct === product.id ? 'translateX(5px)' : 'translateX(0)'
                      }} />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-12 bg-light">
        <div className="container">
          <div className="text-center mb-5 mt-5">
            <h2 className="fw-bold position-relative d-inline-block mb-4 mt-4">
              Why Choose Us
              <div className="position-absolute" style={{ height: '4px', width: '50%', background: '#0891b2', bottom: '-12px', left: '25%', borderRadius: '2px' }}></div>
            </h2>
            <p className="text-secondary lead mx-auto" style={{ maxWidth: '700px' }}>
              As the authorized Sunmi dealer in Bahrain, we provide premium POS solutions with exceptional service and support.
            </p>
          </div>

          <div className="row g-4">
            {[
              { 
                icon: <Shield className="text-primary mb-3" size={36} />, 
                title: "Authorized Dealer", 
                description: "Official Sunmi partner with genuine products and manufacturer warranty" 
              },
              { 
                icon: <Settings className="text-primary mb-3" size={36} />, 
                title: "Technical Support", 
                description: "Expert installation and ongoing maintenance from certified technicians" 
              },
              { 
                icon: <Clock className="text-primary mb-3" size={36} />, 
                title: "Fast Delivery", 
                description: "Quick delivery and setup of your POS system across Bahrain" 
              },
              { 
                icon: <Award className="text-primary mb-3" size={36} />, 
                title: "Quality Assurance", 
                description: "Only the highest quality products that meet international standards" 
              },
              { 
                icon: <Star className="text-primary mb-3" size={36} />, 
                title: "Customer Satisfaction", 
                description: "Dedicated to your satisfaction with personalized solutions" 
              },
              { 
                icon: <ShoppingCart className="text-primary mb-3" size={36} />, 
                title: "Complete Solutions", 
                description: "End-to-end retail and hospitality technology solutions" 
              }
            ].map((feature, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 bg-white shadow-sm p-4 text-center">
                  <div className="card-body">
                    <div className="d-flex justify-content-center">
                      {feature.icon}
                    </div>
                    <h4 className="h5 fw-bold mb-3">{feature.title}</h4>
                    <p className="text-secondary mb-0">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-10 bg-gradient-to-r from-blue-900 to-cyan-800 mt-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 mb-4 mb-lg-0">
              <h3 className="fw-bold mb-3">Ready to upgrade your business technology?</h3>
              <p className="lead mb-0">Contact us today for a consultation and product demonstration.</p>
            </div>
            <div className="col-lg-5 text-lg-end">
              <a href="#contact" className="btn btn-light btn-lg px-5 fw-bold">Get in Touch</a>
            </div>
          </div>
        </div>
      </section>

      {/* Simplified Contact Section */}
      <section id="contact" className="py-12 bg-white mt-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-5">
              <h2 className="fw-bold position-relative mb-4">
                Contact Us
                <div className="position-absolute" style={{ height: '4px', width: '80px', background: '#0891b2', bottom: '-12px', borderRadius: '2px' }}></div>
              </h2>
              <p className=" mb-4">
                Our team of experts is ready to help you find the perfect Sunmi solution for your business needs.
              </p>
              
              <div className="mb-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="rounded-circle bg-primary bg-opacity-10 p-3 me-3">
                    <i className="bi bi-geo-alt text-primary fs-5"></i>
                  </div>
                  <div>
                    <h5 className="mb-1 h6">Location</h5>
                    <p className="mb-0 text-secondary">Salmabad, Kingdom of Bahrain</p>
                  </div>
                </div>
                
                <div className="d-flex align-items-center mb-3">
                  <div className="rounded-circle bg-primary bg-opacity-10 p-3 me-3">
                    <i className="bi bi-telephone text-primary fs-5"></i>
                  </div>
                  <div>
                    <h5 className="mb-1 h6">Phone</h5>
                    <p className="mb-0 text-secondary">+973 33711399 </p>
                  </div>
                </div>
                
                <div className="d-flex align-items-center">
                  <div className="rounded-circle bg-primary bg-opacity-10 p-3 me-3">
                    <i className="bi bi-envelope text-primary fs-5"></i>
                  </div>
                  <div>
                    <h5 className="mb-1 h6">Email</h5>
                    <p className="mb-0 text-secondary">sales@zartecsolutions.com</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-lg-7">
              <div className="card border-0 shadow-sm rounded-3 p-4">
                <div className="card-body">
                  <h3 className="h4 fw-bold mb-4">Send us a message</h3>
                  <form>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label htmlFor="name" className="form-label"></label>
                        <input type="text" className="form-control" id="name" placeholder="Your name" />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="email" className="form-label"></label>
                        <input type="email" className="form-control" id="email" placeholder="Your email" />
                      </div>
                      <div className="col-12">
                        <label htmlFor="phone" className="form-label"></label>
                        <input type="tel" className="form-control" id="phone" placeholder="Your phone number" />
                      </div>
                      <div className="col-12">
                        <label htmlFor="subject" className="form-label"></label>
                        <select className="form-select" id="subject">
                          <option selected>Select an option</option>
                          <option value="pos">POS Terminals</option>
                          <option value="printer">Printers</option>
                          <option value="weighing">Weighing Scales</option>
                          <option value="other">Other Inquiry</option>
                        </select>
                      </div>
                      <div className="col-12">
                        <label htmlFor="message" className="form-label"></label>
                        <textarea className="form-control" id="message" rows="4" placeholder="How can we help you?"></textarea>
                      </div>
                      <div className="col-12">
                        <button 
                          type="submit" 
                          className="btn btn-primary btn-lg px-5"
                          style={{ 
                            background: '#0891b2',
                            border: 'none',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#0e7490';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = '#0891b2';
                          }}
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      {/* <footer className="bg-dark text-white py-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-4">
              <h5 className="fw-bold mb-3">Sunmi Bahrain</h5>
              <p className="text-white-50 mb-4">Authorized dealer for Sunmi POS systems, printers, and retail technology solutions in Bahrain.</p>
              <div className="d-flex gap-2">
                <a href="#" className="btn btn-sm btn-outline-light rounded-circle">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="#" className="btn btn-sm btn-outline-light rounded-circle">
                  <i className="bi bi-instagram"></i>
                </a>
                <a href="#" className="btn btn-sm btn-outline-light rounded-circle">
                  <i className="bi bi-linkedin"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-2 col-6">
              <h6 className="fw-bold mb-3">Products</h6>
              <ul className="list-unstyled">
                <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">V3 Mix</a></li>
                <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">V2S</a></li>
                <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">L2S</a></li>
                <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">T2 Desktop</a></li>
              </ul>
            </div>
            <div className="col-lg-2 col-6">
              <h6 className="fw-bold mb-3">Company</h6>
              <ul className="list-unstyled">
                <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">About Us</a></li>
                <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">Services</a></li>
                <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">Support</a></li>
                <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">Blog</a></li>
              </ul>
            </div>
            <div className="col-lg-4">
              <h6 className="fw-bold mb-3">Newsletter</h6>
              <p className="text-white-50 mb-3">Subscribe to receive updates about new products and offers.</p>
              <div className="input-group mb-3">
                <input type="email" className="form-control" placeholder="Your email" aria-label="Email" />
                <button className="btn btn-primary" type="button" style={{ background: '#0891b2', borderColor: '#0891b2' }}>Subscribe</button>
              </div>
            </div>
          </div>
          <hr className="my-4 border-secondary" />
          <div className="row">
            <div className="col-md-6 text-center text-md-start">
              <p className="mb-0 text-white-50">© 2025 Sunmi Bahrain. All rights reserved.</p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <ul className="list-inline mb-0">
                <li className="list-inline-item"><a href="#" className="text-white-50 text-decoration-none small">Privacy Policy</a></li>
                <li className="list-inline-item ms-3"><a href="#" className="text-white-50 text-decoration-none small">Terms of Use</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer> */}
    </div>
  );
};

export default Sunmiclaude;